<div class="card rounded border">
  <div class="info-container" *ngIf="member$ | async as member">
    <div>
      <label class="mb-0">{{ 'account.details.dob' | translate }}</label>
      <div class="d-flex bg-primary border border-secondary p-2 m-0 mt-1 rounded">
        <span class="icon material-icons" aria-hidden="true">date_range</span>
        <span class="ms-3 text-white">{{ member.DOB | date: 'MMM d, yyy' }}</span>
      </div>
    </div>
    <div>
      <label class="mb-0 personal-info">{{ 'account.details.phone' | translate }}</label>
      <div class="d-flex bg-primary border border-secondary p-2 m-0 mt-1 rounded">
        <span class="icon material-icons" aria-hidden="true">phone</span>
        <span class="ms-3 text-white">{{ member.HomeNumber }}</span>
      </div>
    </div>
    <div>
      <label class="mb-0 personal-info">{{ 'account.details.email' | translate }}</label>
      <div class="d-flex bg-primary border border-secondary p-2 m-0 mt-1 rounded">
        <span class="icon material-icons" aria-hidden="true">email</span>
        <span class="ms-3 text-white">{{ member.EmailAddress1 }}</span>
      </div>
    </div>
    <div>
      <label class="mb-0 personal-info">{{ 'account.details.home.address' | translate }}</label>
      <div class="d-flex bg-primary border border-secondary p-2 m-0 mt-1 rounded">
        <span class="icon material-icons d-inline-block" aria-hidden="true">location_on</span>
        <span class="ms-3 d-inline-block text-white">
          <div>{{ member.AddressName }}</div>
          <div>{{ member.Street }}</div>
          <div>{{ member.Town }}</div>
          <div>{{ member.Country }}</div>
          <div>{{ member.PostCode }}</div>
        </span>
      </div>
    </div>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>